import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

const SEOHead = () => {
  const { t, i18n } = useTranslation();

  useEffect(() => {
    // Update document title
    document.title = t('seo.title');

    // Update meta description
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', t('seo.description'));
    }

    // Update meta keywords
    const metaKeywords = document.querySelector('meta[name="keywords"]');
    if (metaKeywords) {
      metaKeywords.setAttribute('content', t('seo.keywords'));
    }

    // Update language meta tag
    const metaLanguage = document.querySelector('meta[name="language"]');
    if (metaLanguage) {
      metaLanguage.setAttribute('content', i18n.language);
    }

    // Update html lang attribute
    document.documentElement.setAttribute('lang', i18n.language);

    // Update Open Graph meta tags
    const ogTitle = document.querySelector('meta[property="og:title"]');
    if (ogTitle) {
      ogTitle.setAttribute('content', t('seo.ogTitle'));
    }

    const ogDescription = document.querySelector('meta[property="og:description"]');
    if (ogDescription) {
      ogDescription.setAttribute('content', t('seo.ogDescription'));
    }

    // Update Twitter meta tags
    const twitterTitle = document.querySelector('meta[name="twitter:title"]');
    if (twitterTitle) {
      twitterTitle.setAttribute('content', t('seo.twitterTitle'));
    }

    const twitterDescription = document.querySelector('meta[name="twitter:description"]');
    if (twitterDescription) {
      twitterDescription.setAttribute('content', t('seo.twitterDescription'));
    }

    // Update URL meta tags for current language
    const currentUrl = `https://duran.ai/${i18n.language === 'en' ? '' : i18n.language}`;
    
    const ogUrl = document.querySelector('meta[property="og:url"]');
    if (ogUrl) {
      ogUrl.setAttribute('content', currentUrl);
    }

    const twitterUrl = document.querySelector('meta[name="twitter:url"]');
    if (twitterUrl) {
      twitterUrl.setAttribute('content', currentUrl);
    }

    // Add hreflang links for all supported languages
    const supportedLanguages = [
      'en', 'es', 'zh', 'ar', 'hi', 'id', 'kk', 'ky', 
      'mn', 'ko', 'ja', 'vi', 'uz', 'th', 'ne'
    ];

    // Remove existing hreflang links
    document.querySelectorAll('link[hreflang]').forEach(link => link.remove());

    // Add new hreflang links
    supportedLanguages.forEach(lang => {
      const link = document.createElement('link');
      link.rel = 'alternate';
      link.hreflang = lang;
      link.href = `https://duran.ai/${lang === 'en' ? '' : lang}`;
      document.head.appendChild(link);
    });

    // Add x-default hreflang
    const defaultLink = document.createElement('link');
    defaultLink.rel = 'alternate';
    defaultLink.hreflang = 'x-default';
    defaultLink.href = 'https://duran.ai/';
    document.head.appendChild(defaultLink);

  }, [t, i18n.language]);

  return null; // This component doesn't render anything
};

export default SEOHead;